"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _whoAmINames = _interopRequireDefault(require("./whoAmI-names"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RIC_WHOAMI_TYPE_CODE_ADDON_DISTANCE = "VCNL4200";
const RIC_WHOAMI_TYPE_CODE_ADDON_LIGHT = "lightsensor";
const RIC_WHOAMI_TYPE_CODE_ADDON_COLOUR = "coloursensor";
const RIC_WHOAMI_TYPE_CODE_ADDON_IRFOOT = "IRFoot";
const RIC_WHOAMI_TYPE_CODE_ADDON_LEDFOOT = "LEDfoot";
const RIC_WHOAMI_TYPE_CODE_ADDON_LEDARM = "LEDarm";
const RIC_WHOAMI_TYPE_CODE_ADDON_LEDEYE = "LEDeye";
const RIC_WHOAMI_TYPE_CODE_ADDON_NOISE = "noisesensor";
const RIC_WHOAMI_TYPE_CODE_ADDON_GRIPSERVO = "roboservo3";
const EXCLUDED_ADDONS = [(0, _whoAmINames.default)(RIC_WHOAMI_TYPE_CODE_ADDON_LEDFOOT), (0, _whoAmINames.default)(RIC_WHOAMI_TYPE_CODE_ADDON_LEDARM), (0, _whoAmINames.default)(RIC_WHOAMI_TYPE_CODE_ADDON_LEDEYE), (0, _whoAmINames.default)(RIC_WHOAMI_TYPE_CODE_ADDON_GRIPSERVO)];
var _default = exports.default = EXCLUDED_ADDONS;